import moment from "moment";

export const getUserDateFormat = () => {
    const localeDate = new Intl.DateTimeFormat().format(
        new Date(2025, 11, 31)
    );

    const separator = localeDate.match(/[/.-]/)?.[0] || "/";
    const parts = localeDate.split(/[/.-]/);

    if (parts[0] === "31") {
        return `DD${separator}MM${separator}YYYY`;
    }

    if (parts[1] === "31") {
        return `MM${separator}DD${separator}YYYY`;
    }

    if (parts[0] === "2025") {
        return `YYYY${separator}MM${separator}DD`;
    }

    return `DD${separator}MM${separator}YYYY`;
};

export const is24HourFormat = () => {
    const formatted = new Intl.DateTimeFormat(
        navigator.language,
        {
            hour: "numeric",
        }
    ).format(new Date());

    return !formatted.toLowerCase().includes("am")
        && !formatted.toLowerCase().includes("pm");
};

export const formatDateTimeForDisplay = (date?: string) => {
    if (!date) return "";

    const dateFormat = getUserDateFormat();

    return moment(date).format(
        `${dateFormat} hh:mm A`
    );
};

export const formatDateForDisplay = (date?: string) => {
    if (!date) return "";

    return moment(date).format(getUserDateFormat());
};

export const combineDateAndTime = (date: string, time: string) => {
    if (!date) return null;

    // If no time is selected, use midnight
    return new Date(`${date}T${time || "00:00"}:00`).toISOString();
};
